<template>
  <div v-if="isMobile && viewMode === 'map' && !showMobileList" class="absolute bottom-8 left-1/2 -translate-x-1/2 z-20">
    <button
      class="flex items-center gap-2 px-6 py-3 bg-brand text-white rounded-full font-bold shadow-xl hover:bg-brand/90 transition-transform active:scale-95 whitespace-nowrap"
      @click="$emit('toggle')"
    >
      <List :size="20" />
      <span>{{ t('searchResults.showList') || 'Show List' }}</span>
      <span v-if="total > 0" class="flex items-center justify-center bg-white text-brand text-[10px] min-w-5 h-5 px-1.5 rounded-full ml-1 border border-brand/10">
        {{ total }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { List } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';
import { useMediaQuery } from '../composables/useMediaQuery';

defineProps<{
  viewMode: string;
  showMobileList: boolean;
  total: number;
}>();

defineEmits(['toggle']);

const { t } = useI18n();
const isMobile = useMediaQuery('(max-width: 1023px)');
</script>
